import { CenterEvent } from '../../lib/types/models/center-event/center-event'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterEvent(id: number) {
  return restApiClient.url(constructApiUrl(API.centerEvents.get.url, { id })).get<CenterEvent>()
}
